<div #resizeBox class="video-window" [ngStyle]="{ 'min-height': minHeight + 'px', 'max-height': minHeight + 'px' }" cdkDrag>
  <span #dragHandleCorner class="dragHandle corner" cdkDrag (cdkDragMoved)="dragMove(dragHandleCorner, $event)">
    <i class="icon" [ngClass]="'icon-small_resize-handle'" [ngStyle]="{ color: '#4D33CC', visibility: 'visible' }"></i>
  </span>
  <div style="padding: 16px" [ngStyle]="{ 'height': height - 69 + 'px' }">
    <div class="mb-3" fxLayout="row" fxLayoutAlign="space-between start">
      <div #header fxLayout="row" fxLayoutAlign="center">
        @if (icon !== 'traffic-camera') {
          <div class="typeIcon mr-2" style="min-width: 24px; background-color: #3A8E06">
            <i class="icon traffic-icon" [ngClass]="icon" [ngStyle]="{ color: '#FFFFFF', 'font-size.rem': .75 }"></i>
          </div>
        }
        @if (icon === 'traffic-camera') {
          <img src="/assets/images/traffic-cameras/traffic-camera-active-icon.svg" class="mr-2" style="width: 24px; height: 100%" />
        }
        <span class="name mr-2">
          {{ videoStream.name }}
        </span>
      </div>
      <div fxLayout="row" fxLayoutAlign="center">
        @if (zoomToDocumentEnabled) {
          <div class="button mr-4" (click)="zoomToDocument()">
            <i class="icon right-icon icon-zoom-to_location" style="font-size: 1.5rem"></i>
          </div>
        }
        <div class="button" (click)="closeWindow()">
          <i class="icon right-icon icon-small_close-X"></i>
        </div>
      </div>
    </div>
    <div #streamContainer>
      @if (videoStream.type == VideoStreamType.Traffic) {
        <div>
          @if (videoStream.videoUrl != null) {
            <div>
              <div class="video-stream">
                <topo-video-player
              [options]="{
                fluid: true,
                autoplay: true,
                controls: true,
                sources: [{ src: videoStream.videoUrl, type: videoStream.videoType ?? 'application/x-mpegURL' }]
              }"
                  [width]="'100%'"
                  [height]="'auto'"
                (videoLoaded)="setAllHandleTransform()"></topo-video-player>
              </div>
            </div>
          } @else {
            <img class="image-stream" (error)="requestNewVideoStream()" src="{{ refreshImageUrl }}" alt="refreshImageUrl">
          }
        </div>
      }
      @if (videoStream.type == VideoStreamType.Avigilon
        || videoStream.type == VideoStreamType.OpenEye
        || videoStream.type == VideoStreamType.Milestone
        || videoStream.type == VideoStreamType.LiveView
        || videoStream.type == VideoStreamType.MAXPRO) {
        <div>
          <video [autoplay]="true"
            id="video-{{ videoPlayerId }}"
            controls
            src="{{ videoStream.videoUrl }}"
            class="video-stream">
            {{ 'MAP.CAMERA-OFFLINE' | translate }}
          </video>
        </div>
      }
      @if (videoStream.type == VideoStreamType.Salient) {
        <div>
          <img class="image-stream" [src]="refreshImageUrl" [alt]="'MAP.CAMERA-OFFLINE' | translate">
        </div>
      }
      @if (videoStream.type == VideoStreamType.ExacqVision) {
        <div>
          <img class="image-stream" [src]="refreshVmsStreamUrl" [alt]="'MAP.CAMERA-OFFLINE' | translate">
        </div>
      }
      @if (videoStream.type == VideoStreamType.IP) {
        <div class="background">
          <img class="image-stream" [src]="refreshImageUrl" (load)="setAllHandleTransform()" [alt]="'MAP.CAMERA-OFFLINE' | translate">
        </div>
      }
    </div>
  </div>
</div>
